/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as LocaleCurrencyIndexRouteImport } from './routes/$locale.$currency.index'
import { Route as LocaleCurrencySearchRouteImport } from './routes/$locale.$currency.search'
import { Route as LocaleCurrencyPaymentRouteImport } from './routes/$locale.$currency.payment'
import { Route as LocaleCurrencyHelpRouteImport } from './routes/$locale.$currency.help'
import { Route as LocaleCurrencyIdRouteImport } from './routes/$locale.$currency.$id'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const LocaleCurrencyIndexRoute = LocaleCurrencyIndexRouteImport.update({
  id: '/$locale/$currency/',
  path: '/$locale/$currency/',
  getParentRoute: () => rootRouteImport,
} as any)
const LocaleCurrencySearchRoute = LocaleCurrencySearchRouteImport.update({
  id: '/$locale/$currency/search',
  path: '/$locale/$currency/search',
  getParentRoute: () => rootRouteImport,
} as any)
const LocaleCurrencyPaymentRoute = LocaleCurrencyPaymentRouteImport.update({
  id: '/$locale/$currency/payment',
  path: '/$locale/$currency/payment',
  getParentRoute: () => rootRouteImport,
} as any)
const LocaleCurrencyHelpRoute = LocaleCurrencyHelpRouteImport.update({
  id: '/$locale/$currency/help',
  path: '/$locale/$currency/help',
  getParentRoute: () => rootRouteImport,
} as any)
const LocaleCurrencyIdRoute = LocaleCurrencyIdRouteImport.update({
  id: '/$locale/$currency/$id',
  path: '/$locale/$currency/$id',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/$locale/$currency/$id': typeof LocaleCurrencyIdRoute
  '/$locale/$currency/help': typeof LocaleCurrencyHelpRoute
  '/$locale/$currency/payment': typeof LocaleCurrencyPaymentRoute
  '/$locale/$currency/search': typeof LocaleCurrencySearchRoute
  '/$locale/$currency': typeof LocaleCurrencyIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/$locale/$currency/$id': typeof LocaleCurrencyIdRoute
  '/$locale/$currency/help': typeof LocaleCurrencyHelpRoute
  '/$locale/$currency/payment': typeof LocaleCurrencyPaymentRoute
  '/$locale/$currency/search': typeof LocaleCurrencySearchRoute
  '/$locale/$currency': typeof LocaleCurrencyIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/$locale/$currency/$id': typeof LocaleCurrencyIdRoute
  '/$locale/$currency/help': typeof LocaleCurrencyHelpRoute
  '/$locale/$currency/payment': typeof LocaleCurrencyPaymentRoute
  '/$locale/$currency/search': typeof LocaleCurrencySearchRoute
  '/$locale/$currency/': typeof LocaleCurrencyIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/$locale/$currency/$id'
    | '/$locale/$currency/help'
    | '/$locale/$currency/payment'
    | '/$locale/$currency/search'
    | '/$locale/$currency'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/$locale/$currency/$id'
    | '/$locale/$currency/help'
    | '/$locale/$currency/payment'
    | '/$locale/$currency/search'
    | '/$locale/$currency'
  id:
    | '__root__'
    | '/'
    | '/$locale/$currency/$id'
    | '/$locale/$currency/help'
    | '/$locale/$currency/payment'
    | '/$locale/$currency/search'
    | '/$locale/$currency/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  LocaleCurrencyIdRoute: typeof LocaleCurrencyIdRoute
  LocaleCurrencyHelpRoute: typeof LocaleCurrencyHelpRoute
  LocaleCurrencyPaymentRoute: typeof LocaleCurrencyPaymentRoute
  LocaleCurrencySearchRoute: typeof LocaleCurrencySearchRoute
  LocaleCurrencyIndexRoute: typeof LocaleCurrencyIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$locale/$currency/': {
      id: '/$locale/$currency/'
      path: '/$locale/$currency'
      fullPath: '/$locale/$currency'
      preLoaderRoute: typeof LocaleCurrencyIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$locale/$currency/search': {
      id: '/$locale/$currency/search'
      path: '/$locale/$currency/search'
      fullPath: '/$locale/$currency/search'
      preLoaderRoute: typeof LocaleCurrencySearchRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$locale/$currency/payment': {
      id: '/$locale/$currency/payment'
      path: '/$locale/$currency/payment'
      fullPath: '/$locale/$currency/payment'
      preLoaderRoute: typeof LocaleCurrencyPaymentRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$locale/$currency/help': {
      id: '/$locale/$currency/help'
      path: '/$locale/$currency/help'
      fullPath: '/$locale/$currency/help'
      preLoaderRoute: typeof LocaleCurrencyHelpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$locale/$currency/$id': {
      id: '/$locale/$currency/$id'
      path: '/$locale/$currency/$id'
      fullPath: '/$locale/$currency/$id'
      preLoaderRoute: typeof LocaleCurrencyIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  LocaleCurrencyIdRoute: LocaleCurrencyIdRoute,
  LocaleCurrencyHelpRoute: LocaleCurrencyHelpRoute,
  LocaleCurrencyPaymentRoute: LocaleCurrencyPaymentRoute,
  LocaleCurrencySearchRoute: LocaleCurrencySearchRoute,
  LocaleCurrencyIndexRoute: LocaleCurrencyIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
